import React, { useEffect, useState } from 'react';
import { ImpContainer, ImpFlex } from '../..';
import styled, { css, keyframes } from 'styled-components';
const fadeInDown = keyframes `
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const fadeOutDown = keyframes `
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  40% {
    opacity: 0;
  }

  100% {
    opacity: 0;
    transform: translateY(100%);
  }
`;
const CarouselContainer = styled(ImpContainer) `
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
`;
const CarouselItem = styled(ImpContainer) `
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  ${({ animate, isCurrent }) => ((!animate && !isCurrent) || animate) &&
    css `
      opacity: 0;
      transform: translateY(-100%);
    `};

  ${({ isCurrent, animate }) => isCurrent &&
    animate &&
    css `
      animation: ${fadeInDown} 1s forwards;
    `};

  ${({ isPrev, animate }) => isPrev &&
    animate &&
    css `
      animation: ${fadeOutDown} 0.6s forwards;
    `};
`;
const useCarousel = (itemsLength, timeInterval) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [animate, setAnimate] = useState(false);
    const prevIndex = currentIndex === 0 ? itemsLength - 1 : currentIndex - 1;
    useEffect(() => {
        if (itemsLength <= 1)
            return;
        const animationDelayTimer = setTimeout(() => {
            setAnimate(true);
        }, timeInterval);
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % itemsLength);
        }, timeInterval);
        return () => {
            clearTimeout(animationDelayTimer);
            clearInterval(interval);
        };
    }, [itemsLength, timeInterval]);
    return { currentIndex, prevIndex, animate };
};
const ImpCarousel = ({ items, direction = 'vertical', timeInterval = 3000, }) => {
    const { currentIndex, prevIndex, animate } = useCarousel(items.length, timeInterval);
    return (React.createElement(CarouselContainer, { dataTestId: 'carousel-container' }, items.map((item, index) => (React.createElement(CarouselItem, { key: index, isCurrent: index === currentIndex, isPrev: index === prevIndex, animate: animate },
        React.createElement(ImpFlex, { fluid: true, align: "center" }, item))))));
};
export default ImpCarousel;
//# sourceMappingURL=ImpCarousel.js.map